export const useMenuReferrer = () => {
  const referrerValid = () => {
    if (!document.referrer) {
      return false
    }
    const referrerHost = new URL(document.referrer).host
    const currentHost = window.location.host
    return referrerHost === currentHost
  }

  return { referrerValid }
}
